export default "__VITE_ASSET__MST7X$8___"